module.exports = __webpack_public_path__ + "static/media/invoicePendingRequirementsThirdStep.2b918680.png";